import { RouterStore } from '@ibm/mobx-react-router';

import DeviceAnalytics from 'stores/DeviceAnalytics';

import MobileAnalytics from 'stores/MobileAnalytics';

import TaskDetails from 'stores/TaskDetails';

import NotificationSettingsStore from 'stores/NotificationSettings';

import TemplateDetails from 'stores/TemplateDetails';

import FormDetails from 'stores/FormDetails';

import AuditRecordStore from 'stores/AuditRecord';
import AuditFormBuilderStore from 'stores/AuditFormBuilder';
import SiteDetailsStore from 'stores/SiteDetails';

import EntityFields from 'stores/EntityFields';
import OrganisationStructure from 'stores/OrganisationStructure';

import AssetsDetailsStore from 'stores/AssetsDetails/AssetsDetails';

import ContactsDetailsStore from 'stores/ContactsDetails';

import RisksDetailsStore from 'stores/RisksDetails';
import ControlsDetailsStore from 'stores/ControlsDetails';
import HazardsDetailsStore from 'stores/HazardsDetails';

import FormBuilder from 'stores/FormBuilder';

import EventDetailsStore from 'stores/EventDetails/EventDetails';

import RiskAssessmentDetailsStore from 'stores/RiskAssessmentDetails/RiskAssessmentDetails';

import DocumentsDetailsStore from 'stores/DocumentsDetails';
import AssignmentRules from 'stores/AssignmentRules';

import PipelineDetails from 'stores/PipelineDetails';

import ScheduleDetailsStore from 'stores/ScheduleDetails';
import MemberGroupDetailsData from 'stores/MemberGroups';

import FoldersStore from 'stores/Folders';

import KnockInbox from 'stores/KnockInbox';
import KnockGuides from 'stores/KnockGuides';
import KnockPreferencesStore from 'stores/KnockPreferences';
import DualInbox from 'stores/DualInbox';
import { TimezoneStore, timezoneStore } from 'stores/Timezone';
import TimezoneSettingsStore from 'stores/TimezoneSettings';

import { Stores } from './types';
import API from '../../utils/api';
import NotificationStore from '../Notification';
import PendingRedAlertsStore from '../PendingRedAlerts';
import SessionStore from '../Session';
import UserListStore from '../UserList';
import UIStore from '../UI';
import UserDetailsStore from '../UserDetails';
import ActivityMapStore from '../ActivityMap';
import ConfigStore from '../Config';
import DeviceListStore from '../DeviceList';
import DeviceDetailsStore from '../DeviceDetails';
import AlarmDetailsStore from '../AlarmDetails';
import EscalationProfileListStore from '../EscalationProfileList';
import LicensesStore from '../Licenses';
import EscalationProfileDetailsStore from '../EscalationProfileDetailsStore';
import Inbox from '../Inbox';
import Home from '../Home';
import EntityLayout from '../EntityLayout';
import FormBuilderSettingsStore from '../FormBuilderSettings';
import EntitiesFormSubmission from '../EntitiesFormSubmission';

export default class RootStore {
  session: SessionStore;

  routing: RouterStore;

  ui: UIStore;

  userList: UserListStore;

  userDetails: UserDetailsStore;

  notification: NotificationStore;

  activityMap: ActivityMapStore;

  pendingRedAlerts: PendingRedAlertsStore;

  config: ConfigStore;

  deviceList: DeviceListStore;

  deviceDetails: DeviceDetailsStore;

  alarmDetails: AlarmDetailsStore;

  escalationProfileList: EscalationProfileListStore;

  licenses: LicensesStore;

  escalationProfileDetails: EscalationProfileDetailsStore;

  deviceAnalytics: DeviceAnalytics;

  mobileAnalytics: MobileAnalytics;

  taskDetails: TaskDetails;

  notificationSettings: NotificationSettingsStore;

  inbox: Inbox;

  home: Home;

  templateDetails: TemplateDetails;

  formDetails: FormDetails;

  siteDetails: SiteDetailsStore;

  auditRecord: AuditRecordStore;

  auditFormBuilder: AuditFormBuilderStore;

  assetDetails: AssetsDetailsStore;

  contactDetails: ContactsDetailsStore;

  riskDetails: RisksDetailsStore;
  controlDetails: ControlsDetailsStore;
  hazardDetails: HazardsDetailsStore;

  riskAssessmentDetails: RiskAssessmentDetailsStore;

  eventDetails: EventDetailsStore;

  entityFields: EntityFields;

  organisationStructure: OrganisationStructure;

  entityLayout: EntityLayout;

  formBuilder: FormBuilder;

  formBuilderSettings: FormBuilderSettingsStore;

  entitiesFormSubmission: EntitiesFormSubmission;

  documentsDetails: DocumentsDetailsStore;

  assignmentRules: AssignmentRules;

  pipelineDetails: PipelineDetails;

  scheduleDetails: ScheduleDetailsStore;

  memberGroupDetails: MemberGroupDetailsData;

  folders: FoldersStore;

  knockInbox: KnockInbox;

  knockGuides: KnockGuides;

  knockPreferences: KnockPreferencesStore;

  dualInbox: DualInbox;

  timezone: TimezoneStore;

  timezoneSettings: TimezoneSettingsStore;

  constructor() {
    this.session = new SessionStore(this, API);
    this.routing = new RouterStore();
    this.ui = new UIStore(this, API);
    this.userList = new UserListStore(this, API);
    this.userDetails = new UserDetailsStore(this, API);
    this.notification = new NotificationStore(this);
    this.activityMap = new ActivityMapStore(this, API);
    this.pendingRedAlerts = new PendingRedAlertsStore(this, API);
    this.config = new ConfigStore(this, API);
    this.deviceList = new DeviceListStore(this, API);
    this.deviceDetails = new DeviceDetailsStore(this, API);
    this.alarmDetails = new AlarmDetailsStore(this, API);
    this.escalationProfileList = new EscalationProfileListStore(this, API);
    this.licenses = new LicensesStore(this, API);
    this.escalationProfileDetails = new EscalationProfileDetailsStore(this, API);
    this.deviceAnalytics = new DeviceAnalytics(this, API);
    this.mobileAnalytics = new MobileAnalytics(this, API);
    this.taskDetails = new TaskDetails(this, API);
    this.notificationSettings = new NotificationSettingsStore(this, API);
    this.inbox = new Inbox(this, API);
    this.home = new Home(this, API);
    this.templateDetails = new TemplateDetails(this, API);
    this.formDetails = new FormDetails(this, API);
    this.siteDetails = new SiteDetailsStore(this, API);
    this.auditRecord = new AuditRecordStore(this, API);
    this.auditFormBuilder = new AuditFormBuilderStore(this, API);
    this.assetDetails = new AssetsDetailsStore(this, API);
    this.entityFields = new EntityFields(this, API);
    this.organisationStructure = new OrganisationStructure(this, API);
    this.entityLayout = new EntityLayout(this, API);
    this.contactDetails = new ContactsDetailsStore(this, API);
    this.riskDetails = new RisksDetailsStore(this, API);
    this.controlDetails = new ControlsDetailsStore(this, API);
    this.hazardDetails = new HazardsDetailsStore(this, API);
    this.riskAssessmentDetails = new RiskAssessmentDetailsStore(this, API);
    this.formBuilder = new FormBuilder(this, API);
    this.eventDetails = new EventDetailsStore(this, API);
    this.formBuilderSettings = new FormBuilderSettingsStore(this, API);
    this.entitiesFormSubmission = new EntitiesFormSubmission(this, API);
    this.documentsDetails = new DocumentsDetailsStore(this, API);
    this.assignmentRules = new AssignmentRules(this, API);
    this.pipelineDetails = new PipelineDetails(this, API);
    this.scheduleDetails = new ScheduleDetailsStore(this, API);
    this.memberGroupDetails = new MemberGroupDetailsData(this, API);
    this.folders = new FoldersStore(this, API);
    this.knockInbox = new KnockInbox(this, API);
    this.knockGuides = new KnockGuides(this, API);
    this.knockPreferences = new KnockPreferencesStore(this);
    this.dualInbox = new DualInbox(this, this.inbox, this.knockInbox);
    this.timezone = timezoneStore;
    this.timezoneSettings = new TimezoneSettingsStore(this, API);
  }

  get stores(): Stores {
    return {
      root: this,
      session: this.session,
      routing: this.routing,
      ui: this.ui,
      userList: this.userList,
      userDetails: this.userDetails,
      notification: this.notification,
      activityMap: this.activityMap,
      pendingRedAlerts: this.pendingRedAlerts,
      config: this.config,
      deviceList: this.deviceList,
      deviceDetails: this.deviceDetails,
      alarmDetails: this.alarmDetails,
      escalationProfileList: this.escalationProfileList,
      licenses: this.licenses,
      escalationProfileDetails: this.escalationProfileDetails,
      deviceAnalytics: this.deviceAnalytics,
      mobileAnalytics: this.mobileAnalytics,
      taskDetails: this.taskDetails,
      notificationSettings: this.notificationSettings,
      inbox: this.inbox,
      home: this.home,
      templateDetails: this.templateDetails,
      formDetails: this.formDetails,
      siteDetails: this.siteDetails,
      auditRecord: this.auditRecord,
      auditFormBuilder: this.auditFormBuilder,
      assetDetails: this.assetDetails,
      entityFields: this.entityFields,
      organisationStructure: this.organisationStructure,
      entityLayout: this.entityLayout,
      contactDetails: this.contactDetails,
      riskDetails: this.riskDetails,
      controlDetails: this.controlDetails,
      hazardDetails: this.hazardDetails,
      riskAssessmentDetails: this.riskAssessmentDetails,
      formBuilder: this.formBuilder,
      eventDetails: this.eventDetails,
      formBuilderSettings: this.formBuilderSettings,
      entitiesFormSubmission: this.entitiesFormSubmission,
      documentsDetails: this.documentsDetails,
      assignmentRules: this.assignmentRules,
      pipelineDetails: this.pipelineDetails,
      scheduleDetails: this.scheduleDetails,
      memberGroupDetails: this.memberGroupDetails,
      folders: this.folders,
      knockInbox: this.knockInbox,
      knockGuides: this.knockGuides,
      knockPreferences: this.knockPreferences,
      dualInbox: this.dualInbox,
      timezone: this.timezone,
      timezoneSettings: this.timezoneSettings,
    };
  }
}
